import { createContext } from 'react';

import { DEFAULT_SCALE } from '../constants';
import type { LightboxControls } from './types';

export const LightboxControlsContext = createContext<LightboxControls>({
  setPage: () => {},
  setNumPages: () => {},
  previousPage: () => {},
  nextPage: () => {},
  setScale: () => {},
  increaseScale: () => {},
  decreaseScale: () => {},
  resetScale: () => {},
  setContentContainerSize: () => {},
  page: 1,
  numPages: 1,
  scale: DEFAULT_SCALE,
  initialScale: null,
  contentMargin: 0,
  contentContainerSize: { width: 0, height: 0 },
});
